import type { ReactNode } from "react";

interface RebuildHeaderProps {
  rightSection?: ReactNode;
}

export const RebuildHeader = ({ rightSection }: RebuildHeaderProps) => {
  return (
    <div className="flex h-[52px] flex-row items-center justify-between border-b-1 border-[#eeeff1] px-4 py-2">
      <div className="flex flex-row items-center space-x-2">
        <img src="/logo-black.svg" alt="Rebuild" className="h-5" />
      </div>
      {rightSection}
    </div>
  );
};
